
import styled from "styled-components";
import {getCssSizeValue} from "@repo/utils";
import {BREAKPOINTS} from "../../../../styles/themeSettings";
export const MainWrapper = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    width: 100%;
    align-items: ${({left}) => left ? 'flex-end' : 'flex-start'};
`

export const RowWrapper = styled.div`
    --column-gap: ${getCssSizeValue(10, BREAKPOINTS.MOBILE)};
    display: flex;
    align-items: center;
    z-index: 1;
    flex-wrap: wrap;
    column-gap: var(--column-gap);

    .image {
        transform: translateX(calc(var(--image) * 1%));
        transform-origin: ${({ $left }) => $left ? 'right center' : 'left center'};
        z-index: 2;
    }

    a {
        height: auto;
    }

    //.transparent-3d {
    //    color: rgba(186, 72, 74, 0.52);
    //}

    @media (min-width: ${({theme}) => theme?.breakpoints?.tablet || 768}px) {
        --column-gap: ${getCssSizeValue(20, BREAKPOINTS.TABLET)};
    }
    @media (min-width: ${({theme}) => theme?.breakpoints?.desktop || 1024}px) and (orientation: landscape) {
        --column-gap: ${getCssSizeValue(30, BREAKPOINTS.DESKTOP)};
    }
`;

export const BreakWrapper = styled.span`
	display: flex;
	align-items: center !important;
    justify-content: center;
`
